var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetwork = function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#network_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.217 24.857 4.6.913a4.087 4.087 0 1 0 .35-1.743l-4.72-.937a6.7 6.7 0 0 0-1.876-4.628l6.11-8.63a5.166 5.166 0 1 0-1.45-1.028l-6.05 8.546a6.705 6.705 0 0 0-8.5 1.333l-7.942-6.168a4.095 4.095 0 1 0-1.143 1.363l8.096 6.287a6.706 6.706 0 0 0 1.666 8.046l-4.92 6.956a5.517 5.517 0 1 0 1.356 1.161l5.053-7.145a6.71 6.71 0 0 0 5.49.123l5.994 8.856a4.646 4.646 0 1 0 1.447-1.034l-5.909-8.729a6.74 6.74 0 0 0 2.348-3.542"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "network_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h46v46H0z"
  })))));
};
export default SvgNetwork;